import React from 'react'
import styled from 'styled-components'
import NumberFormat from 'react-number-format'

const Input = styled.input`
    width: 100%;
	padding: 6px 0 7px;
	height: 19px;
	font-size: 16px;

    + div {
        left: 0;
        right: 0;
        bottom: 0;
        content: "";
        position: absolute;
        transform: scaleX(0);
        pointer-events: none;
		transition: transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms;
		border-bottom: 2px solid #415dd4;
    }
`

const Label = styled.div`
	font-weight: 700;
	font-size: 13.5px;
	line-height: 1;
	margin-bottom: 5px;
`

const Container = styled.div`
	width: 50%;
	box-sizing: border-box;
	position: relative;
	margin-bottom: 30px;

	&:before {
		content: '';
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		border-bottom: 1px solid rgba(0, 0, 0, 0.42);
	}

	:hover {
		&:before {
			border-bottom: 2px solid #4a4a4a;
		}
	}

	> input {
		${props => props.invalid && `
			+ div {
				border-bottom: 2px solid #f44336;
				transform: scaleX(1);
			}
		`}

		${props => !props.invalid && `
			:focus {
				+ div {
					transform: scaleX(1);
				}
			}
		`}
	}
`

const Number = ({label, config, defaultValue, fieldId, readonly, invalid, handleChange}) => {
	const onChange = (values) => {
		handleChange('c' + fieldId, values.floatValue)
	}

	return (
		<Container invalid={invalid} data-id={invalid ? fieldId : null}>
			<Label dangerouslySetInnerHTML={{__html: label}} />
			<NumberFormat
				customInput={Input}
				defaultValue={config && config.decimalLength === 0 ? parseInt(defaultValue) : defaultValue}
				thousandSeparator=' '
				suffix={config && config.currencyPosition === 2 && config.currencySymbol ? ' ' + config.currencySymbol : ''}
				prefix={config && config.currencyPosition === 1 && config.currencySymbol ? config.currencySymbol + ' ' : ''}
				decimalSeparator={config ? config.decimalSeparator : ','}
				decimalScale={config && config.decimalLength ? + config.decimalLength : 0}
				fixedDecimalScale={true}
				onValueChange={onChange}
				readOnly={readonly}
			/>
			<div />
		</Container>
	)
}

export default React.memo(Number)